import { render } from "./SummaryMetricCard.vue?vue&type=template&id=0325a670&scoped=true"
import script from "./SummaryMetricCard.vue?vue&type=script&lang=js"
export * from "./SummaryMetricCard.vue?vue&type=script&lang=js"

import "./SummaryMetricCard.vue?vue&type=style&index=0&id=0325a670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0325a670"]])

export default __exports__